export default {
  prehospitalCares: [],
  prehospitalCare: null
}
